import { ReactElement } from 'react';
import 'newcomponents/Shared/LeaderBoardCustomTab/index.less';
import 'newcomponents/Shared/LeaderBoardCustomTab/LeaderBoardRow/index.less';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './style.less';

const CustomSkeleton = (
  <Skeleton title={{ style: { width: '100%' } }} paragraph={true} active />
);

export const SidebarSkeleton = (): ReactElement => (
  <div className="tabsWrapper tabsWrapper--notIsCasino">
    <div className="sidebarRow">{CustomSkeleton}</div>
    <div className="sidebarRow">{CustomSkeleton}</div>
    <div className="sidebarRow">{CustomSkeleton}</div>
  </div>
);

export const DesktopTournamentSingleViewSkeleton = (): ReactElement => {
  return (
    <>
      <div className="tournamentSingleView__banner tournamentSingleView__banner__img tournamentSingleView__banner__skeleton">
        <Skeleton.Image
          style={{
            width: '100%',
            height: 450
          }}
        />
      </div>
      <div className="tournamentSingleView__infoContainer">
        <div className="tournamentSingleView__infoContainer__mainSection">
          <div className="tournamentSingleView__infoContainer__mainSection__tournamentInfo">
            <Skeleton
              title={{ style: { width: '100%' } }}
              paragraph={true}
              active
            />
          </div>
          <div className="tournamentSingleView__infoContainer__mainSection__tournamentInfo">
            <Skeleton
              title={{ style: { width: '100%' } }}
              paragraph={true}
              active
            />
          </div>
          <div className="tournamentSingleView__infoContainer__mainSection__subSection">
            {CustomSkeleton}
          </div>
        </div>
        <SidebarSkeleton />
      </div>
    </>
  );
};
